module.exports = __webpack_public_path__ + "media/favicon/apple-touch-icon-f22ad6f149dd1c3d7709fb43e5440178.png";